/**
 * 前端 JWT 工具：只「解析」payload 讀 exp / claim，不做簽章驗證（驗證是後端的事）。
 */

export interface JwtClaims {
  sub?: string;
  jwt_type?: 'session' | 'tenant_scoped' | 'platform';
  tenant_id?: string;
  role?: 'admin' | 'editor' | 'viewer';
  is_platform_admin?: boolean;
  exp?: number; // epoch seconds
  iat?: number;
  iss?: string;
}

/** 解析 JWT payload（base64url）。失敗回 null。 */
export function decodeJwt(token: string): JwtClaims | null {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    return JSON.parse(json) as JwtClaims;
  } catch {
    return null;
  }
}

/** token 是否已過期（或無法解析）。提前 30 秒視為過期，避免邊界請求失敗。 */
export function isExpired(token: string | null | undefined, skewSeconds = 30): boolean {
  if (!token) return true;
  const claims = decodeJwt(token);
  if (!claims?.exp) return true;
  const nowSec = Date.now() / 1000;
  return claims.exp - skewSeconds <= nowSec;
}
